import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { UnitSystem } from '../models';

@Injectable({
  providedIn: 'root',
})
export class UnitSystemsService {
  constructor(private http: HttpClient) {}

  public getUnitSystems(): Observable<UnitSystem[]> {
    return this.http.get<UnitSystem[]>(`${environment.calculationApi}/v1/unit-systems`);
  }
}
